// EmailJS Configuration
export const EMAILJS_CONFIG = {
  SERVICE_ID: 'service_cb7ikgw',
  TEMPLATE_ID: 'template_cq6apu2',
  PUBLIC_KEY: 'ZyvKQhg0-4O9nzKq2',
  RECIPIENT_EMAIL: 'swastikrajvanshsingh0@gmail.com'
}; 